/**
 * Interop type from i-lab.model.ts {@link ILab}
 */
export type ILabInterop = {
    id: number;
    title: string;
};

export function toILabInterop(item: any): ILabInterop {
    return {
        id: item.id,
        title: item.title,
    };
}
